var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-container"},[_c('video',_vm._b({ref:"videoPlayerRef",staticClass:"video-js vjs-fluid vjs-default-skin",attrs:{"controls":"","preload":"auto","poster":_vm.poster}},'video',_vm.$attrs,false),[_c('source',{attrs:{"src":_setup.source,"type":"application/x-mpegURL"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }